import { Query, toQuery } from "../helpers/general";

const DASHBOARD_ROUTE = "/";
const path = (baseUrl: string, subUrl: string) => `${baseUrl}${subUrl}`;

export const DASHBOARD_ROUTES = {
  places: {
    list: path(DASHBOARD_ROUTE, "places"),
    invoice: (placeId: string) =>
      path(DASHBOARD_ROUTE, `places/${placeId}/invoices`),
    service: (placeId: string) =>
      path(DASHBOARD_ROUTE, `places/${placeId}/services`),
    gallery: (placeId: string) =>
      path(DASHBOARD_ROUTE, `places/${placeId}/gallery`),
    reviews: (placeId: string) =>
      path(DASHBOARD_ROUTE, `places/${placeId}/ratings`),
    inspectors: (placeId: string) =>
      path(DASHBOARD_ROUTE, `places/${placeId}/inspectors`),
    floor_planner: (placeId: string) =>
      path(DASHBOARD_ROUTE, `places/${placeId}/planner`),
  },
  payment: {
    list: (query: Query) => path(DASHBOARD_ROUTE, `payouts${toQuery(query)}`),
  },
  invoices: {
    list: () => path(DASHBOARD_ROUTE, "invoices"),
  },
  taxi: {
    discounts: {
      list: () => path(DASHBOARD_ROUTE, "taxi/discounts"),
      new: () => path(DASHBOARD_ROUTE, "taxi/discounts/new"),
      update: (id: string) =>
        path(DASHBOARD_ROUTE, `taxi/discounts/update/${id}`),
    },
  },
  reward: {
    list: () => path(DASHBOARD_ROUTE, "rewards"),
    new: () => path(DASHBOARD_ROUTE, "rewards/new"),
    update: (id: string) => path(DASHBOARD_ROUTE, `rewards/update/${id}`),
  },
};
